const LogoutContent = () => null;

export default LogoutContent;
